import { saleDashboardApi } from "../../api";

const SaleDashboardService = {
  /**
   * 📊 Obtiene estadísticas generales del dashboard de ventas.
   */
  getStats: async () => {
    const response = await saleDashboardApi.fetchCustom("/stats");
    return response.data;
  },

  /**
   * 📅 Obtiene ventas mensuales por año.
   *
   * @param year Año a consultar (por defecto el año actual)
   * @returns Objeto con labels ["Ene", "Feb", ...] y values [120, 300, ...]
   */
  getMonthlySalesByYear: async (year: number = new Date().getFullYear()) => {
    const response = await saleDashboardApi.fetchCustom(`/monthly?year=${year}`);
    return response.data;
  },

  /**
   * 📆 Obtiene ventas diarias dentro de un mes específico del año.
   *
   * @param year Año de la consulta (ejemplo: 2025)
   * @param month Mes de la consulta (1-12)
   * @returns Objeto con labels ["1","2","3",...] y values [100,200,...]
   */
  getDailySalesByYearAndMonth: async (year: number, month: number) => {
    const response = await saleDashboardApi.fetchCustom(`/daily?year=${year}&month=${month}`);
    return response.data;
  },
};

export default SaleDashboardService;
